var map = {
	"./2020/bronze.jpg": "c4ac",
	"./2020/gold.jpg": "90f3",
	"./2020/silver.jpg": "a844",
	"./2021/bronze.jpg": "2a3d",
	"./2021/gold.jpg": "a732",
	"./2021/silver.jpg": "1e8b",
	"./2022/bronze.jpg": "efed",
	"./2022/gold.jpg": "0314",
	"./2022/silver.jpg": "79d2",
	"./2022/venture.jpg": "e1a5",
	"./2023/bronze.jpg": "a47e",
	"./2023/gold.jpg": "84e0",
	"./2023/silver.jpg": "2943",
	"./2024/bronze.jpg": "11da",
	"./2024/gold.jpg": "7302",
	"./2024/silver.jpg": "c8b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65c0";